module.exports = __webpack_public_path__ + "images/7a519a52b89267ea8470fc7727375593.svg";